import { URLS } from "@/constants/urls";
import { CareerFormData } from "@/types/forms";
import { postFormData } from "./post-form-data/post-form-data";

type Response = {
    message: string
}

export const postJoinUsForm = postFormData<CareerFormData, Response>(URLS.CareerForm)